module.exports = __webpack_public_path__ + "img/jellybean_terrain.604af963.png";